import {css, StyleSheet} from 'aphrodite';
import React, {useState} from 'react';
import _ from 'underscore';

import {ConnectionSchema} from 'instruments/connection-schemas/ConnectionSchemaConstants';
import {InstrumentAdapter} from 'instruments/connections/ConnectionConstants';
import {listAdapters} from 'instruments/connections/ConnectionDAO';
import SelectDropdown from 'ui-library/dropdowns/SelectDropdown';
import useOnMount from 'ui-library/hooks/useOnMount';
import FieldLabel from 'ui-library/inputs/FieldLabel';
import InputWrapper from 'ui-library/inputs/InputWrapper';
import Menu from 'ui-library/menus/Menu';
import Option from 'ui-library/menus/Option';

interface AdapterSelectorProps {
  value: string | null;
  onChange: (adapterId: string) => void;
  schema?: ConnectionSchema | null;
}

export default function AdapterSelector(props: AdapterSelectorProps): JSX.Element {
  const [adapters, setAdapters] = useState([] as Array<InstrumentAdapter>);
  useOnMount((): void => {
    listAdapters().then(({instrumentAdapters}) => {
      setAdapters(instrumentAdapters);
    });
  });
  const selectedAdapter = adapters.find((adapter) => adapter.id === props.value);
  return (
    <InputWrapper
      id={_.uniqueId('adapterId')}
      label="Integration Adapter"
      labelStyle={FieldLabel.STYLES.LABEL}
      isRequired={true}
    >
      {props.schema == null ? (
        <SelectDropdown
          className={css(styles.dropdown)}
          displayName={selectedAdapter ? selectedAdapter.displayName : 'None'}
          menu={
            <Menu value={props.value} height={Menu.HEIGHTS.MEDIUM} width={Menu.WIDTHS.FULL} scrollable={true}>
              {adapters.map((adapter) => (
                <Option
                  key={adapter.id}
                  value={adapter.id}
                  onSelect={() => {
                    props.onChange(adapter.id);
                  }}
                >
                  {adapter.displayName}
                </Option>
              ))}
            </Menu>
          }
        />
      ) : (
        <span className="settingsPageContainer-readOnlyValue">{selectedAdapter?.displayName}</span>
      )}
    </InputWrapper>
  );
}

const styles = StyleSheet.create({
  dropdown: {
    flex: 1,
  },
});
